
export function toSatoshis(bch: number): number {
    return Math.floor(bch * 100000000);
}

export function fromSatoshis(sats: number): number {
    return sats / 100000000.0;
}

export function base64ToHex(base64: string, upperCase: boolean = false): string {
    const raw = atob(base64);
    let result = '';
    for (let i = 0; i < raw.length; i++) {
        const hex = raw.charCodeAt(i).toString(16);
        result += (hex.length === 2 ? hex : '0' + hex);
    }
    return upperCase === true ? result.toUpperCase() : result;
}

export function hexToBase64(hex: string): string {
    return btoa(
        String.fromCharCode(
            ...hex
                .match(/.{2}/g)
                .map(c => parseInt(c, 16))
        )
    );
}

export function reverseBytes(buffer: string): string {
    let bytes = buffer.match(/[a-fA-F0-9]{2}/g);
    if (bytes === null)
        throw new Error("Can not reverse bytes of invalid buffer: " + buffer);
    return bytes.reverse().join('');
}
